<nz-row>
  <nz-col nzSpan="24">
    <nz-list *ngIf="herausgebers.result$ | async" nzSize="large" [nzLoading]="$loading | async">
      <nz-list-item *ngFor="let herausgeber of (herausgebers.result$ | async).herausgebers" (click)="select.emit(herausgeber)">
        <nz-list-item-meta [nzDescription]="ListDescription">
          <ng-template #ListDescription>
            <!--- << description    -->
            <!---    description >> -->
          </ng-template>
          <nz-list-item-meta-title>
            <a>
              <!--- << content    -->
              {{ herausgeber.name }}
              <nz-divider nzType="vertical"></nz-divider>
              <a *ngIf="herausgeber.website" [href]="herausgeber.website" target="_blank">
                {{ herausgeber.website }}
              </a>
              <!---    content >> -->
            </a>
          </nz-list-item-meta-title>
        </nz-list-item-meta>
        <ul nz-list-item-actions>
          <nz-list-item-action>
            <a><i nz-icon nzType="edit" nzTheme="outline"></i></a>
          </nz-list-item-action>
        </ul>
      </nz-list-item>
    </nz-list>
  </nz-col>
</nz-row>
